<script lang="ts">
	import type { PageData } from './$types';
	import Homepage from '$lib/components/Storyblok/Homepage.svelte';
	import { onMount } from 'svelte';
	import { useStoryblokBridge } from '@storyblok/svelte';

	export let data: PageData;

	onMount(() => {
		useStoryblokBridge(data.story.id, (newStory) => (data.story = newStory));
	});
</script>

<Homepage content={data.story.content} />
